<template>
  <div>
    <router-link
        to="/geia"
        class="text-lg py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
    >
      <a
          class="hover:text-blueGray-500 text-blueGray-700 px-3 py-2 flex items-center text-lg uppercase font-bold"
          ref="btnDropdownRef"
          style="font-size:18px"
      >
        Gene Expression Analysis
      </a>
    </router-link>
<!--    <div-->
<!--        ref="popoverDropdownRef"-->
<!--        class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"-->
<!--        v-bind:class="{-->
<!--        hidden: !dropdownPopoverShow,-->
<!--        block: dropdownPopoverShow,-->
<!--      }"-->
<!--    >-->
<!--      <span-->
<!--          class="text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"-->
<!--      >-->
<!--        Data-->
<!--      </span>-->
<!--      <router-link-->
<!--          to="/gene_expression"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Gene Expression-->
<!--      </router-link>-->
<!--      <router-link-->
<!--          to="/rna_seqid"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        RNA-Seq ID-->
<!--      </router-link>-->
<!--      <router-link-->
<!--          to="/annotation"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Annotation-->
<!--      </router-link>-->
<!--      <div class="h-0 mx-4 my-2 border border-solid border-blueGray-100"/>-->
<!--      <span-->
<!--          class="text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"-->
<!--      >-->
<!--        Analysis-->
<!--      </span>-->
<!--      <router-link-->
<!--          to="/blast"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Blast-->
<!--      </router-link>-->
<!--      <div class="h-0 mx-4 my-2 border border-solid border-blueGray-100"/>-->
<!--      <span-->
<!--          class="text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-blueGray-400"-->
<!--      >-->
<!--        Result-->
<!--      </span>-->
<!--      <router-link-->
<!--          to="/conserved_motif"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Conserved Motif-->
<!--      </router-link>-->
<!--      <router-link-->
<!--          to="/phylogenetic_tree"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Phylogenetic Tree-->
<!--      </router-link>-->
<!--      <router-link-->
<!--          to="/pathway"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Pathway-->
<!--      </router-link>-->
<!--      <router-link-->
<!--          to="/psd"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Protein Structure and Docking-->
<!--      </router-link>-->
<!--      <router-link-->
<!--          to="/differential_expression"-->
<!--          class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"-->
<!--      >-->
<!--        Differential Expression-->
<!--      </router-link>-->
<!--    </div>-->
  </div>
</template>
<script>
import {createPopper} from "@popperjs/core";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },
  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
  },
};
</script>
